import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import App from './App';
import store from './redux/store';

import { ClerkProvider } from '@clerk/clerk-react';
import { ModalViewer } from "react-easetools";
import Notifications from 'react-notify-toast';
import Toast from './components/common/Toast';
import './index.css';
const ErrorBoundary = React.lazy(() => import('./pages/Error/ErrorBoundary'));

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

(async () => {


  ReactDOM
    .createRoot(document.getElementById('root') as HTMLElement)
    .render(<>
        <ModalViewer></ModalViewer>
        <Provider store={store}>
          <ErrorBoundary>
            {clerkPubKey && (
              <ClerkProvider
              appearance={{
                layout: {
                  logoImageUrl: "http://localhost:3000/static/media/cp.efc18886c96d199aea1e.png",
                  logoPlacement: "inside",
                  showOptionalFields: true,
                  socialButtonsPlacement: "bottom",
                  socialButtonsVariant: "iconButton",
                }
              }}
              publishableKey={clerkPubKey}
              >
                <App />
                <Toast />
                <Notifications />
              </ClerkProvider>
            )}
          </ErrorBoundary>
        </Provider>
            </>
    );
})();
